export default __webpack_public_path__ + "static/media/h_1.d71a0474.jpeg";